<template>
  <v-container>
    <v-row justify="end">
      <RequiredItemText/>
    </v-row>
    <!-- <v-row id="companyName">
      <FormItem :name="label('companyName')" required>
        <TextField
          v-model="companyName"
          :name="label('companyName')"
          :max="50"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row> -->
    <v-row>
      <FormItem :name="label('business')">
        <TextArea
                v-model="business"
                :name="label('business')"
                :max="2000"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="establishedYear">
      <FormItem :name="label('establishedYear')">
        <SelectField
                v-model="establishedYear"
                :name="label('establishedYear')"
                :items="years"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="representative">
      <FormItem :name="label('representative')">
        <TextField
          v-model="representative"
          :name="label('representative')"
          :max="100"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="numberOfEmployees">
      <FormItem :name="label('numberOfEmployees')">
        <SelectField
                v-model="numberOfEmployees"
                :name="label('numberOfEmployees')"
                row
                :items="numbers"
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="netSales">
      <FormItem :name="label('netSales')">
        <TextField
          v-model="netSales"
          :name="label('netSales')"
          :max="100"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="zipCode">
      <FormItem :name="label('zipCode')" required>
        <PostalCodeField
          v-model="zipCode"
          :name="label('zipCode')"
          required
        />
      </FormItem>
    </v-row>
    <v-row id="prefecture">
      <FormItem :name="label('prefecture')" required>
        <SelectField
                v-model="prefecture"
                :name="label('prefecture')"
                :items="prefectures"
                required
                :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="address">
      <FormItem :name="label('address')" required>
        <TextField
          v-model="address"
          :name="label('address')"
          :max="90"
          required
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="building">
      <FormItem :name="label('building')">
        <TextField
          v-model="building"
          :name="label('building')"
          :max="100"
          :submit="submit"
        />
      </FormItem>
    </v-row>
    <v-row id="url">
      <FormItem :name="label('url')">
        <UrlField
          v-model="url"
          :name="label('url')"
        />
      </FormItem>
    </v-row>
    <v-row>
      <FormItem :name="label('logo')">
        <div style="width: 120px; margin-bottom: 16px;">
          <UserImage :src="iconUrl" company/>
        </div>
        <FileSelectField
                v-model="icon"
                :name="label('logo')"
                image
                :max-size="10 * 1024 * 1024"
                :submit="submit"
        />
      </FormItem>
    </v-row>
  </v-container>
</template>

<script>
  import TextField from "../atoms/TextField";
  import FormItem from "../molecules/FormItem";
  import SelectField from "../atoms/SelectField";
  import moment from "moment";
  import FileSelectField from "../atoms/FileSelectField";
  import TextArea from "../atoms/TextArea";
  import RequiredItemText from "../atoms/RequiredItemText";
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import UserImage from "../atoms/UserImage";
  import PostalCodeField from "@/components/molecules/PostalCodeField";
  import UrlField from "@/components/molecules/UrlField";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "CompanyProfileForm",
    props: {
      "value": {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        iconData: null
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      // companyName: {
      //   get () {
      //     return this.value.name
      //   },
      //   set (value) {
      //     this.$emit("input", {...this.value, name: value})
      //   }
      // },
      establishedYear: {
        get () {
          return this.value.establishedYear
        },
        set (value) {
          this.$emit("input", {...this.value, establishedYear: value})
        }
      },
      business: {
        get () {
          return this.value.business
        },
        set (value) {
          this.$emit("input", {...this.value, business: value})
        }
      },
      representative: {
        get () {
          return this.value.representative
        },
        set (value) {
          this.$emit("input", {...this.value, representative: value})
        }
      },
      corporateNumber: {
        get () {
          return this.value.corporateNumber
        },
        set (value) {
          this.$emit("input", {...this.value, corporateNumber: value})
        }
      },
      numberOfEmployees: {
        get () {
          return this.value.numberOfEmployees
        },
        set (value) {
          this.$emit("input", {...this.value, numberOfEmployees: value})
        }
      },
      netSales: {
        get () {
          return this.value.netSales
        },
        set (value) {
          this.$emit("input", {...this.value, netSales: value})
        }
      },
      icon: {
        get () {
          return this.value.iconFile
        },
        set (value) {
          this.$emit("input", {...this.value, iconFile: value})
          const reader = new FileReader();
          reader.onload = (e) => {
            this.iconData = e.target.result;
          };
          reader.readAsDataURL(value);
        }
      },
      iconUrl () {
        if (this.iconData) {
          return this.iconData;
        }
        return this.value.logoUrl;
      },
      zipCode: {
        get () {
          return this.value.zipCode
        },
        set (value) {
          this.$emit("input", {...this.value, zipCode: value})
        }
      },
      prefecture: {
        get () {
          return parseInt(this.value.prefecture)
        },
        set (value) {
          this.$emit("input", {...this.value, prefecture: value})
        }
      },
      address: {
        get () {
          return this.value.address
        },
        set (value) {
          this.$emit("input", {...this.value, address: value})
        }
      },
      building: {
        get () {
          return this.value.building
        },
        set (value) {
          this.$emit("input", {...this.value, building: value})
        }
      },
      url: {
        get () {
          return this.value.url
        },
        set (value) {
          this.$emit("input", {...this.value, url: value})
        }
      },
      years () {
        const years = [];
        const currentYear = moment().year();
        for (let year = currentYear; year >= 1900; year--) {
          years.push({label: year, value: year})
        }
        return years;
      },
      prefectures () {
        return this.consts.prefectures.filter(pre => pre.value !== 48) // 海外を除いておく
      },
      numbers () {
        return this.consts.numberOfEmployees
      },
    },
    methods: {
      submit () {
      }
    },
    components: {
      UrlField,
      PostalCodeField,
      UserImage,
      FormItem,
      TextField,
      SelectField,
      FileSelectField,
      TextArea,
      RequiredItemText,
    }
  }
</script>

<style scoped>

</style>
